import { motion } from "framer-motion";
import { Hand } from "lucide-react";
import { Reveal, Chapter } from "./Reveal";
import { PhoneMockup } from "./PhoneMockup";

export const Groups = () => (
    <section className="mx-auto max-w-6xl px-6 py-24 sm:py-32" data-testid="groups-section">
        <div className="grid items-center gap-14 lg:grid-cols-2 lg:gap-20">
            <Reveal delay={0.1} className="order-last flex justify-center lg:order-first lg:justify-start">
                <PhoneMockup
                    src="/assets/screens/the-room-lunar.webp"
                    alt="The room in Lunar — people and groups at the same place, ready to wave"
                    testId="groups-phone-mockup"
                />
            </Reveal>
            <Reveal>
                <Chapter index="05" label="Groups" />
                <h2
                    data-testid="groups-heading"
                    className="font-display mt-5 text-4xl font-medium leading-[1.1] tracking-tight text-[#1D201A] sm:whitespace-nowrap sm:text-[2.6rem]"
                >
                    Out with others?
                    <motion.span
                        data-testid="groups-wave-icon"
                        className="ml-3 inline-flex h-10 w-10 translate-y-1 items-center justify-center rounded-full bg-[#D5D8CB] align-middle"
                        style={{ transformOrigin: "70% 80%" }}
                        animate={{ rotate: [0, 16, -8, 14, 0] }}
                        transition={{
                            duration: 1.6,
                            repeat: Infinity,
                            repeatDelay: 2.4,
                            ease: "easeInOut",
                        }}
                        aria-hidden="true"
                    >
                        <Hand className="h-5 w-5 text-[#2C3618]" strokeWidth={1.75} />
                    </motion.span>
                </h2>
                <p className="mt-5 max-w-md text-base leading-relaxed text-[#5C5F58] sm:text-lg">
                    Create a Lunar group, get the people you’re with to join with a PIN, and
                    meet other groups together.
                </p>
            </Reveal>
        </div>
    </section>
);
